import React, { Component, PropTypes } from 'react';
import {

} from 'material-ui';
import RequestRow from './request-row';

class RequestList extends Component {
  render() {
    const {
      list,
      className,
    } = this.props;

    return (<div className={className}>
      <div>
        <div className="flex-center" style={{ lineHeight: '56px', borderBottom: '1px solid #e0e0e0', color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px' }}>
          <div style={{ padding: '0 88px', width: '65%' }}>
            Request
          </div>
          <div style={{ padding: 0, textAlign: 'center', width: '15%' }}>
            Status
          </div>
          <div style={{ padding: 0, textAlign: 'center', width: '10%' }}>
            Periods
          </div>
          <div style={{ padding: 0, textAlign: 'center', width: '8%' }}>
            Date Received
          </div>
        </div>
        <div style={{ overflow: 'visible' }} >
          {
            list.map((request, i) => (
              <RequestRow
                key={i}
                request={request}
              />))
          }
        </div>
      </div>
      <div style={{ display: (list && list.length) ? 'none' : 'block', minHeight: '100px', fontSize: '24px', textAlign: 'center', marginTop: '50px', marginBottom: '50px' }}>
        There are no files in this category.
      </div>
    </div>);
  }
}

export default RequestList;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/basic-request-list/request-list.jsx